<template>
  <div
    class="c-anim-scroll"
    :class="{'is-visible': isInViewport}"
    :style="{transitionDuration: duration + 'ms', transitionDelay: (staggerDelay + delay) + 'ms', opacity: isInViewport || !isFade ? 1 : 0, transform: isInViewport || !isTranslate ? 'translateZ(0)' : 'translateY(20px) translateZ(0)'}">
    <slot></slot>
  </div>
</template>

<script>
export default {

  props: {
    duration:     { type: Number, default: 1200 },
    isFade:     { type: Boolean, default: true },
    isTranslate:  { type: Boolean, default: true },
    margin:     { type: Number, default: .2 },
    removeOnLeave:  { type: Boolean, default: false },
    delay:      { type: Number, default: 0 },
    maxStagger:   { type: Number, default: 700 },
    isStagger:    { type: Boolean, default: false },
  },

  data() {
    return {
      isInViewport: false,
      staggerDelay: 0
    }
  },

  created() {
    this.timeout =  null
  },

  mounted() {
    this.onResize()
    this.onScroll()
  },

  destroyed() {
    clearTimeout( this.timeout )
  },

  methods: {
    onResize() {
      this.offset   = this.$offset.absolute( this.$el )
      this.height   = this.$el.offsetHeight
      this.margins  = this.margin * this.$device.height

      if( this.isStagger ) {
        this.staggerDelay = this.maxStagger * this.offset.left / this.$device.width
      }

      this.onScroll()
    },

    onScroll() {
      let isInViewport = this.getIsInViewport(this.offset.top + this.margins, this.height)

      if( this.removeOnLeave || isInViewport && !this.isInViewport ) {
        this.isInViewport = isInViewport
        return
      }
    },
    getIsInViewport(offsetTop, height) {
      if( offsetTop + height > this.$device.scroll.top && offsetTop < this.$device.scroll.top + this.$device.height ) {
        return true;
      }
      else {
        return false;
      }
    }
  },

  watch: {
    isInViewport() {
      if( this.isInViewport ) {
        this.timeout = setTimeout( ()=>{
        }, this.delay + this.staggerDelay)
      }
      else if ( this.removeOnLeave && !this.isInViewport ) {
        clearTimeout( this.timeout )
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/easings'

.c-anim-scroll
  transition-timing-function ease-in-out-quart
</style>